/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 */

import { ILabelStyles } from '@fluentui/react/lib/Label';
import { IMessageBarStyles } from '@fluentui/react/lib/MessageBar';
import { IStackStyles } from '@fluentui/react/lib/Stack';
import { ITheme } from '@fluentui/react/lib/Styling';
import { CSSProperties } from 'react';

export const getStackStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            height: '100%',
            position: 'relative',
        },
    };
};

export const getFormContainerStyles = (): Partial<IStackStyles> => {
    return {
        root: {
            height: '100%',
            position: 'relative',
            marginBottom: '-0.5rem',
        },
    };
};

export const getSubStackStyles = (theme: ITheme): Partial<IStackStyles> => {
    return {
        root: { position: 'absolute', background: theme.palette.neutralLighterAlt, width: '70%', height: '100%' },
    };
};

export const getFormsDesignTimeIframeStyles = (): Partial<CSSProperties> => {
    return {
        display: 'block',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
        minWidth: '640px',
    };
};

export const getDescriptionStyles = (theme: ITheme): Partial<ILabelStyles> => {
    return {
        root: {
            color: theme.palette.neutralDark,
            padding: 0,
            fontWeight: 'normal',
        },
    };
};

export const getMessageBarStyles = (theme: ITheme): Partial<IMessageBarStyles> => {
    return {
        root: {
            margin: '-1.25rem -2.875rem 1.25rem -2.875rem',
            width: 'auto',
        },
        iconContainer: {
            display: 'none',
        },
        text: {
            justifyContent: 'center',
            color: theme.palette.red,
        },
    };
};
